import { wwtModalManagerLog } from '../logger/wwtModalManagerLog.ts'
import { ModalInfo, ModalTypes } from '../types/modalTypes.ts'

export const getChildModalsInfoFromModalTree = (
	modals: ModalInfo<ModalTypes>[],
	ids: string[],
	level = 0
) => {
	let modalsInner = modals

	ids.slice(0, ids.length - level).forEach(id => {
		if (!modalsInner) {
			wwtModalManagerLog(
				`Error: Not find ${id} in modals`,
				JSON.stringify(modals)
			)
			throw new Error(`Not find ${id} in modals`)
		}

		const childModal = modalsInner.find(modal => modal.id.includes(id))

		if (!childModal) {
			wwtModalManagerLog(
				`Modal ${id} not found in parent modal`,
				JSON.stringify(modalsInner)
			)
			throw new Error(`Modal ${id} not found in parent modal`)
		}

		modalsInner = childModal.childModals
	})

	return modalsInner
}
